import { Outlet } from "react-router-dom";

export default function RightPanel() {
  return (
    <div className="flex min-h-0 flex-1">
      <Outlet />
    </div>
  );
}
